import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from 'components/shared/CustomAlert/CustomAlertContain';
import CustomAutocomplete from 'components/shared/CustomAutocomplete/CustomAutocomplete';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomCheckbox from 'components/shared/CustomCheckbox/CustomCheckbox';
import CustomDatePicker from 'components/shared/CustomDatePicker/CustomDatePicker';
import CustomTextField from 'components/shared/CustomTextField/CustomTextField';
import { useInput } from 'customHook/useInput';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { ClientService } from 'service/client.service';
import { HuddleClientService } from 'service/huddle-client.service';
import { LocationService } from 'service/location.service';
import zeplinColor from 'theme/Color';
import { ClientType } from 'utilities/constants';
import validator from 'validator';

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
    },
  },
};
const PositionMapping: Record<string, string[]> = {
  NFL: [
    'QB',
    'RB',
    'FB',
    'WR',
    'TE',
    'LT',
    'LG',
    'C',
    'RG',
    'RT',
    'DE',
    'OLB',
    'MLB',
    'DB',
    'S',
    'K',
    'P',
    'LS',
    'KR',
    'PR',
  ],
  NBA: ['Guard', 'Forward', 'Center'],
};

const TeamMapping: Record<string, string[]> = {
  NFL: [
    'Arizona Cardinals',
    'Atlanta Falcons',
    'Baltimore Ravens',
    'Buffalo Bills',
    'Carolina Panthers',
    'Chicago Bears',
    'Cincinnati Bengals',
    'Cleveland Browns',
    'Dallas Cowboys',
    'Denver Broncos',
    'Detroit Lions',
    'Green Bay Packers',
    'Houston Texans',
    'Indianapolis Colts',
    'Jacksonville Jaguars',
    'Kansas City Chiefs',
    'Las Vegas Raiders',
    'Los Angeles Chargers',
    'Los Angeles Rams',
    'Miami Dolphins',
    'Minnesota Vikings',
    'New England Patriots',
    'New Orleans Saints',
    'New York Giants',
    'New York Jets',
    'Philadelphia Eagles',
    'Pittsburgh Steelers',
    'San Francisco 49ers',
    'Seattle Seahawks',
    'Tampa Bay Buccaneers',
  ],
  NBA: [
    'Atlanta Hawks',
    'Boston Celtics',
    'Brooklyn Nets',
    'Charlotte Hornets',
    'Chicago Bulls',
    'Cleveland Cavaliers',
    'Dallas Mavericks',
    'Denver Nuggets',
    'Detroit Pistons',
    'Golden State Warriors',
    'Houston Rockets',
    'Indiana Pacers',
    'LA Clippers',
    'Los Angeles Lakers',
    'Memphis Grizzlies',
    'Miami Heat',
    'Milwaukee Bucks',
    'Minnesota Timberwolves',
    'New Orleans Pelicans',
    'New York Knicks',
    'Oklahoma City Thunder',
    'Orlando Magic',
    'Philadelphia 76ers',
    'Phoenix Suns',
    'Portland Trail Blazers',
    'Sacramento Kings',
    'San Antonio Spurs',
    'Toronto Raptors',
    'Utah Jazz',
    'Washington Wizards',
  ],
  Other: ['Other'],
};
const AtheleteForm = ({
  handleSelection,
  setSelectedItems,
  selectedItems,
  data,
  getAllClient,
  onClose,
}: {
  handleSelection: (item: any, type: string | boolean) => void;
  setSelectedItems: React.Dispatch<
    React.SetStateAction<{
      salutation: string[];
      agency: any[];
      league: string[];
      team: string[];
      position: string[];
      number: string[];
      status: string[];
      college: string[];
      time: string[];
      client: boolean[];
      type: string[];
      industry: string[];
      category: string[];
      captiv8: any[];
    }>
  >;
  selectedItems: {
    salutation: string[];
    agency: any[];
    league: string[];
    team: string[];
    position: string[];
    number: string[];
    status: string[];
    college: string[];
    time: string[];
    client: boolean[];
    type: string[];
    industry: string[];
    category: string[];
    captiv8: any[];
  };
  data?: any;
  getAllClient: () => Promise<void>;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xl'));

  const [formLoading, setFormLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [date, setDate] = useState<Dayjs | null>(data?.birthdate ? dayjs(data?.birthdate) : null);
  const [agencyData, setAgencyData] = useState<any[]>([]);
  const [dropdowns, setDropdowns] = useState<any>({});
  const [client, setClient] = useState(data ? data?.isPersonAccount : true);
  const [sameBilling, setSameBilling] = useState(true);
  const [selectedAddressSuggestion, setSelectedAddressSuggestion] = useState({ Name: '', ID: '' });
  const [billingSuggestion, setBillingSuggestion] = useState({ Name: '', ID: '' });
  const [address, setAddress] = useState<any[]>([]);
  const wait = useRef<any>();

  const {
    handleChange: handleFirstNameChange,
    handleBlur: handleFirstNameBlur,
    value: firstName,
    invalid: invalidFirstName,
    didChange: didFirstNameChange,
  } = useInput(data ? data?.accountName : '', () => true);
  const {
    handleChange: handleNumberChange,
    handleBlur: handleNumberBlur,
    value: number,
    invalid: invalidNumber,
    didChange: didNumberChange,
  } = useInput(data ? data?.number : '', () => true);
  const {
    handleChange: handleMobileChange,
    handleBlur: handleMobileBlur,
    value: mobile,
    invalid: invalidMobile,
    didChange: didMobileChange,
  } = useInput(data ? data?.mobile : '', () => true);
  const {
    handleChange: handlePhoneChange,
    handleBlur: handlePhoneBlur,
    value: phone,
    invalid: invalidPhone,
    didChange: didPhoneChange,
  } = useInput(data ? data?.phone : '', () => true);
  const {
    handleChange: handleLoanChange,
    handleBlur: handleLoanBlur,
    value: loan,
    invalid: invalidLoan,
    didChange: didLoanChange,
  } = useInput(data?.loanOutCompany ? data?.loanOutCompany : '', () => true);
  const {
    handleChange: handleEmailChange,
    handleBlur: handleEmailBlur,
    value: email,
    invalid: invalidEmail,
    didChange: didEmailChange,
  } = useInput(data ? data?.email : '', validator.isEmail);
  const {
    handleChange: handlePersonalEmailChange,
    handleBlur: handlePersonalEmailBlur,
    value: personalEmail,
    invalid: invalidPersonalEmail,
    didChange: didPersonalEmailChange,
  } = useInput(data ? data?.personalEmail : '', validator.isEmail);
  const {
    handleChange: handleStreetChange,
    handleBlur: handleStreetBlur,
    setValue: setStreet,
    value: street,
    invalid: invalidStreet,
    didChange: didStreetChange,
  } = useInput(data?.mailingAddress?.street ? data?.mailingAddress?.street : '', () => true);
  const {
    handleChange: handleCityChange,
    handleBlur: handleCityBlur,
    setValue: setCity,
    value: city,
    invalid: invalidCity,
    didChange: didCityChange,
  } = useInput(data?.mailingAddress?.city ? data?.mailingAddress?.city : '', () => true);
  const {
    handleChange: handleStateChange,
    handleBlur: handleStateBlur,
    setValue: setState,
    value: state,
    invalid: invalidState,
    didChange: didStateChange,
  } = useInput(data?.mailingAddress?.state ? data?.mailingAddress?.state : '', () => true);
  const {
    handleChange: handleZipChange,
    handleBlur: handleZipBlur,
    value: zip,
    invalid: invalidZip,
    didChange: didZipChange,
  } = useInput(
    data?.mailingAddress?.postalCode ? data?.mailingAddress?.postalCode : '',
    () => true,
  );
  const {
    handleChange: handleCountryChange,
    handleBlur: handleCountryBlur,
    setValue: setCountry,
    value: country,
    invalid: invalidCountry,
    didChange: didCountryChange,
  } = useInput(data?.mailingAddress?.country ? data?.mailingAddress?.country : '', () => true);

  const {
    handleChange: handleBillingStreetChange,
    handleBlur: handleBillingStreetBlur,
    value: billingStreet,
    setValue: setBillingStreet,
    invalid: invalidBillingStreet,
    didChange: didBillingStreetChange,
  } = useInput(data?.billingAddress?.street ? data?.billingAddress?.street : '', () => true);

  const {
    handleChange: handleBillingCityChange,
    handleBlur: handleBillingCityBlur,
    setValue: setBillingCity,
    value: billingCity,
    invalid: invalidBillingCity,
    didChange: didBillingCityChange,
  } = useInput(data?.billingAddress?.city ? data?.billingAddress?.city : '', () => true);

  const {
    handleChange: handleBillingStateChange,
    handleBlur: handleBillingStateBlur,
    setValue: setBillingState,
    value: billingState,
    invalid: invalidBillingState,
    didChange: didBillingStateChange,
  } = useInput(data?.billingAddress?.state ? data?.billingAddress?.state : '', () => true);
  const {
    handleChange: handleBillingZipChange,
    handleBlur: handleBillingZipBlur,
    value: billingZip,
    invalid: invalidBillingZip,
    didChange: didBillingZipChange,
  } = useInput(
    data?.billingAddress?.postalCode ? data?.billingAddress?.postalCode : '',
    () => true,
  );
  const {
    handleChange: handleBillingCountryChange,
    handleBlur: handleBillingCountryBlur,
    setValue: setBillingCountry,
    value: billingCountry,
    invalid: invalidBillingCountry,
    didChange: didBillingCountryChange,
  } = useInput(data?.billingAddress?.country ? data?.billingAddress?.country : '', () => true);
  const {
    handleChange: handleBioChange,
    handleBlur: handleBioBlur,
    value: bio,
  } = useInput(data ? data?.bio : '', () => true);

  const handleDeleteItems = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    setSelectedItems({
      ...selectedItems,
      [key]: [...selectedItems.agency?.filter((val: any) => val !== item)],
    });
  };

  const suggestionAPI = async (value: string) => {
    try {
      setLoading(true);
      const res = await LocationService.getAddressSuggestion(value?.toLocaleLowerCase());
      setAddress(res.map((val: any) => ({ ID: val?.description, Name: val?.description })));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddressSearch = async (e: React.SyntheticEvent, value: string) => {
    clearTimeout(wait.current);
    const getSuggestion = setTimeout(() => suggestionAPI(value), 1000);
    wait.current = getSuggestion;
  };
  const getDropdownValue = async (type: string) => {
    try {
      const res = await ClientService.getClientDropdowns(type);
      setDropdowns(res);
      setAgencyData(res?.agency);
    } catch (err) {
      console.error(err);
    }
  };
  const addClient = async () => {
    try {
      setFormLoading(true);
      const props = {
        Name: `${firstName}`,
        ...(date && { PersonBirthdate: date }),
        RecordTypeName: ClientType.Athlete,
        ...(selectedItems?.captiv8[0] && { Captive8_Creator_Id__c: selectedItems?.captiv8[0]?.Id }),
        ...(selectedItems?.agency[0]?.Id && {
          Agency__c: selectedItems?.agency[0]?.Id,
        }),
        PersonMobilePhone: mobile,
        BillingAddress: {
          city: sameBilling ? city : billingCity,
          country: sameBilling ? country : billingCountry,
          state: sameBilling ? state : billingState,
          street: sameBilling ? street : billingStreet,
          postalCode: sameBilling ? zip : billingZip,
        },
        PersonMailingAddress: {
          city: city,
          country: country,
          state: state,
          street: street,
          postalCode: zip,
        },
        Number__c: +number,
        GD_Bio__c: bio,
        ...(selectedItems?.league[0] &&
          selectedItems?.league[0] !== 'None' && { League__c: selectedItems.league[0] || '' }),
        ...(selectedItems?.team[0] &&
          selectedItems?.team[0] !== 'None' && { Team__c: selectedItems.team[0] || '' }),
        ...(selectedItems?.position[0] &&
          selectedItems?.position[0] !== 'None' && {
            Position__c: selectedItems.position[0] || '',
          }),
        ...(selectedItems?.status[0] &&
          selectedItems?.status[0] !== 'None' && { Status__c: selectedItems.status[0] || '' }),
        ...(selectedItems?.college[0] &&
          selectedItems?.college[0] !== 'None' && { College__c: selectedItems.college[0] || '' }),
        Personal_Email__pc: personalEmail,
        PersonEmail: email,
        Loan_Out_Company__c: loan,
        Industry: 'Fashion',
        Client__c: client,
      };
      let res;

      res = data?.accountId
        ? await HuddleClientService?.editHuddleClient(props, data?.accountId)
        : await HuddleClientService.addHuddleClient(props);
      client && sessionStorage.setItem('platform', 'huddle');
      client && sessionStorage.setItem('new-client', res?.recordId || res?.clientId);
      data?.accountId && getAllClient();
      onClose(false);
    } catch (err) {
      setError(true);
    } finally {
      setFormLoading(false);
    }
  };

  const disable = !(firstName && selectedItems?.agency[0]);

  useEffect(() => {
    getDropdownValue(ClientType.Athlete);
  }, []);

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Account Information
          </Typography>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <FormControl sx={{ width: '100%', flex: 1 }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                Salutation
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                value={
                  typeof selectedItems.salutation == 'string'
                    ? selectedItems.salutation
                    : selectedItems.salutation[0]
                }
                onChange={(e) => handleSelection(e, 'salutation')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Salutation'
                  />
                }
                renderValue={(selected) => {
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.Salutation ?? []), 'None'].map((name: string) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={selectedItems.salutation.indexOf(name) > -1}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                    />

                    {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <CustomTextField
              style={{ width: '100%', flex: { xs: 2, xl: 3 } }}
              onBlur={handleFirstNameBlur}
              onChange={handleFirstNameChange}
              name='Name'
              text={firstName}
              form={true}
              error={invalidFirstName && didFirstNameChange ? 'Please enter valid First Name' : ''}
              label={'Name'}
              type='text'
              tabindex={1}
              required
            />
          </Box>

          <CustomDatePicker
            value={date}
            setValue={setDate}
            label='Birth date'
            size={isXs ? 'small' : 'medium'}
          />
          <CustomAutocomplete
            popupIcon='/assets/Search.svg'
            required={true}
            options={agencyData || []}
            getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
            label={'Agency'}
            handleDeleteItems={handleDeleteItems}
            selectedItems={selectedItems}
            handleSelection={(value) => {
              handleSelection(value, 'agency');
            }}
            value={selectedItems?.agency[0]}
            handleFilter={() => {}}
            placeholder='Search agency'
            currentLength={dropdowns?.agency?.length}
            totalLength={dropdowns?.agency?.length}
            next={() => {}}
            multiple={false}
          />
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <FormControl sx={{ width: '100%', flex: 1 }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                League
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                value={
                  typeof selectedItems.league == 'string'
                    ? selectedItems.league
                    : selectedItems.league[0]
                }
                onChange={(e) => {
                  handleSelection(e, 'league');
                  setSelectedItems((prev) => ({ ...prev, team: [], position: [] }));
                }}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='League'
                  />
                }
                renderValue={(selected) => {
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.League__c ?? []), 'None'].map((name: string) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={selectedItems.league.indexOf(name) > -1}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                    />

                    {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ width: '100%', flex: 1 }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                Team
              </InputLabel>
              <Select
                disabled={
                  ['None', 'Other']?.includes(selectedItems?.team[0]) || !selectedItems?.team
                }
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                value={
                  typeof selectedItems.team == 'string' ? selectedItems.team : selectedItems.team[0]
                }
                onChange={(e) => handleSelection(e, 'team')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Team'
                  />
                }
                renderValue={(selected) => {
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.Team__c ?? []), 'None'].map(
                  (name) =>
                    TeamMapping[selectedItems?.league[0]]
                      ?.map((val: any) => val?.toLocaleLowerCase())
                      ?.includes(name?.toLocaleLowerCase()) && (
                      <MenuItem key={name} value={name}>
                        <Radio
                          checked={selectedItems.team.indexOf(name) > -1}
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />

                        {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                      </MenuItem>
                    ),
                )}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <FormControl sx={{ width: '100%', flex: 1 }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                Position
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                value={
                  typeof selectedItems.position == 'string'
                    ? selectedItems.position
                    : selectedItems.position[0]
                }
                onChange={(e) => handleSelection(e, 'position')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Position'
                  />
                }
                renderValue={(selected) => {
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.Position__c ?? []), 'None'].map(
                  (name) =>
                    PositionMapping[selectedItems?.league[0]]
                      ?.map((val: any) => val?.toLocaleLowerCase())
                      ?.includes(name?.toLocaleLowerCase()) && (
                      <MenuItem key={name} value={name}>
                        <Radio
                          checked={selectedItems.position.indexOf(name) > -1}
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />

                        {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                      </MenuItem>
                    ),
                )}
              </Select>
            </FormControl>

            <CustomTextField
              style={{ width: '100%', flex: 1 }}
              onBlur={handleNumberBlur}
              onChange={handleNumberChange}
              name='Number'
              text={number}
              form={true}
              error={invalidNumber && didNumberChange ? 'Please enter valid Last Name' : ''}
              label={'Number'}
              type='number'
              max={99}
              tabindex={1}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <FormControl sx={{ width: '100%', flex: 1 }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                Status
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                value={
                  typeof selectedItems.status == 'string'
                    ? selectedItems.status
                    : selectedItems.status[0]
                }
                onChange={(e) => handleSelection(e, 'status')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Status'
                  />
                }
                renderValue={(selected) => {
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.Status__c ?? []), 'None'].map((name) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={selectedItems.status.indexOf(name) > -1}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                    />

                    {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ width: '100%', flex: 1 }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                College
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                size={isXs ? 'small' : 'medium'}
                value={
                  typeof selectedItems.college == 'string'
                    ? selectedItems.college
                    : selectedItems.college[0]
                }
                onChange={(e) => handleSelection(e, 'college')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='College'
                  />
                }
                renderValue={(selected) => {
                  return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
                }}
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {[...(dropdowns?.College__c ?? []), 'None'].map((name) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={selectedItems.college.indexOf(name) > -1}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                    />

                    {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <CustomTextField
            style={{ width: '100%', flex: 3 }}
            onBlur={handleLoanBlur}
            onChange={handleLoanChange}
            name='Loan out company'
            text={loan}
            form={true}
            error={invalidLoan && didLoanChange ? 'Please enter valid First Name' : ''}
            label={'Loan out company'}
            type='text'
            tabindex={1}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Contact Information
          </Typography>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handleMobileBlur}
              onChange={handleMobileChange}
              name='Mobile'
              text={mobile}
              form={true}
              error={invalidMobile && didMobileChange ? 'Please enter valid Mobile' : ''}
              label={'Mobile'}
              tabindex={1}
              isPhoneMask
            />
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handlePhoneBlur}
              onChange={handlePhoneChange}
              name='Phone'
              text={phone}
              form={true}
              error={invalidPhone && didPhoneChange ? 'Please enter valid Phone' : ''}
              label={'Phone'}
              tabindex={1}
              isPhoneMask
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handleEmailBlur}
              onChange={handleEmailChange}
              name='Email'
              text={email}
              form={true}
              error={invalidEmail && didEmailChange ? 'Please enter valid Email' : ''}
              label={'Email'}
              type='text'
              tabindex={1}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%', flex: 3 }}
              onBlur={handlePersonalEmailBlur}
              onChange={handlePersonalEmailChange}
              name='Personal Email'
              text={personalEmail}
              form={true}
              error={
                invalidPersonalEmail && didPersonalEmailChange
                  ? 'Please enter valid Personal Email'
                  : ''
              }
              label={'Personal Email'}
              type='text'
              tabindex={1}
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Mailing Address
          </Typography>
          <CustomAutocomplete
            loading={loading}
            popupIcon='/assets/Search.svg'
            required={false}
            options={address || []}
            getOptionLabel={(option: any) => option?.Name}
            label={'Address'}
            handleDeleteItems={handleDeleteItems}
            selectedItems={selectedItems}
            handleSelection={(value) => {
              setSelectedAddressSuggestion(value);
              setStreet(value?.Name.split(',')[0]);

              setCity(value?.Name.split(',')[value?.Name.split(',')?.length - 3]);
              setState(value?.Name.split(',')[value?.Name.split(',')?.length - 2]);
              setCountry(value?.Name.split(',')[value?.Name.split(',')?.length - 1]);
            }}
            value={selectedAddressSuggestion}
            handleFilter={handleAddressSearch}
            placeholder='Search address'
            currentLength={address?.length || 0}
            totalLength={address?.length || 0}
            next={() => {}}
            multiple={false}
          />
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleStreetBlur}
              onChange={handleStreetChange}
              name='Street'
              text={street}
              form={true}
              error={invalidStreet && didStreetChange ? 'Please enter valid Street' : ''}
              label={'Street'}
              type='text'
              tabindex={1}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleCityBlur}
              onChange={handleCityChange}
              name='City'
              text={city}
              form={true}
              error={invalidCity && didCityChange ? 'Please enter valid City' : ''}
              label={'City'}
              type='text'
              tabindex={1}
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleStateBlur}
              onChange={handleStateChange}
              name='State/Province'
              text={state}
              form={true}
              error={invalidState && didStateChange ? 'Please enter valid State' : ''}
              label={'State/Province'}
              type='text'
              tabindex={1}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleZipBlur}
              onChange={handleZipChange}
              name='Zip/Postal code'
              text={zip}
              form={true}
              error={invalidZip && didZipChange ? 'Please enter valid Zip' : ''}
              label={'Zip/Postal code'}
              type='number'
              tabindex={1}
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleCountryBlur}
              onChange={handleCountryChange}
              name='Country'
              text={country}
              form={true}
              error={invalidCountry && didCountryChange ? 'Please enter valid Country' : ''}
              label={'Country'}
              type='text'
              tabindex={1}
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
            Billing Address
          </Typography>
          <CustomCheckbox
            label='My billing address is same as my mailing address'
            checked={sameBilling}
            onChange={(checked) => {
              setSameBilling(checked);
            }}
          />
          <CustomAutocomplete
            loading={loading}
            popupIcon='/assets/Search.svg'
            required={false}
            options={address || []}
            getOptionLabel={(option: any) => option?.Name}
            label={'Search address'}
            handleDeleteItems={handleDeleteItems}
            selectedItems={selectedItems}
            handleSelection={(value) => {
              setBillingSuggestion(value);
              setBillingStreet(value?.Name.split(',')[0]);
              setBillingCity(value?.Name.split(',')[value?.Name.split(',')?.length - 3]);
              setBillingState(value?.Name.split(',')[value?.Name.split(',')?.length - 2]);
              setBillingCountry(value?.Name.split(',')[value?.Name.split(',')?.length - 1]);
            }}
            value={billingSuggestion}
            handleFilter={handleAddressSearch}
            placeholder='Search address'
            currentLength={address?.length || 0}
            totalLength={address?.length || 0}
            next={() => {}}
            multiple={false}
          />
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingStreetBlur}
              onChange={handleBillingStreetChange}
              name='Street'
              text={sameBilling ? street : billingStreet}
              form={true}
              error={
                invalidBillingStreet && didBillingStreetChange ? 'Please enter valid Street' : ''
              }
              label={'Street'}
              type='text'
              tabindex={1}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingCityBlur}
              onChange={handleBillingCityChange}
              name='City'
              text={sameBilling ? city : billingCity}
              form={true}
              error={invalidBillingCity && didBillingCityChange ? 'Please enter valid City' : ''}
              label={'City'}
              type='text'
              tabindex={1}
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingStateBlur}
              onChange={handleBillingStateChange}
              name='State/Province'
              text={sameBilling ? state : billingState}
              form={true}
              error={invalidBillingState && didBillingStateChange ? 'Please enter valid State' : ''}
              label={'State/Province'}
              type='text'
              tabindex={1}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingZipBlur}
              onChange={handleBillingZipChange}
              name='Zip/Postal code'
              text={sameBilling ? zip : billingZip}
              form={true}
              error={invalidBillingZip && didBillingZipChange ? 'Please enter valid Zip' : ''}
              label={'Zip/Postal code'}
              type='number'
              tabindex={1}
            />
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleBillingCountryBlur}
              onChange={handleBillingCountryChange}
              name='Country'
              text={sameBilling ? country : billingCountry}
              form={true}
              error={
                invalidBillingCountry && didBillingCountryChange ? 'Please enter valid Country' : ''
              }
              label={'Country'}
              type='text'
              tabindex={1}
            />
          </Box>
          <CustomTextField
            style={{ width: '100%' }}
            onBlur={handleBioBlur}
            onChange={handleBioChange}
            name='Bio'
            text={bio}
            form={true}
            error={false}
            label={'Bio'}
            multiline
            type='text'
            tabindex={1}
          />
        </Box>
      </Box>
      <Box
        sx={{
          width: '100%',
          position: 'sticky',
          bottom: '0px',
          margin: 'auto',
          zIndex: '100',
          padding: '24px 0px',
          backgroundColor: zeplinColor.Neutral1,
        }}
      >
        <CustomButton
          disabled={disable || formLoading}
          onClick={() => {
            addClient();
          }}
          variant='contained'
          color={disable ? 'customDisable' : 'primary'}
          style={{
            borderRadius: '14px',
            height: 56,
            width: '100%',
            '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
          }}
          textStyle={{ color: disable ? zeplinColor.Neutral8 : zeplinColor.Neutral1 }}
          text={
            formLoading
              ? data?.accountId
                ? 'Saving'
                : 'Creating Client...'
              : data?.accountId
                ? 'Save'
                : 'Create Client'
          }
        />
      </Box>
      <CustomAlert
        open={error}
        handleClose={() => {
          setError(false);
        }}
        message={
          <CustomAlertContain
            alertIcon={<img src='/assets/error.svg' width={24} height={24} />}
            alert={'Something went wrong.'}
            error
          />
        }
        error
      />
    </>
  );
};

export default AtheleteForm;
